import React, { Component } from 'react'
import { faEnvelope, faLink } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Sharer from 'sharer.npm.js'
import _ from 'lodash'
import moment from 'moment'

//Local modules

class SharePopover extends Component {
    constructor(props) {
        super(props)

        this.state = { copySuccess: '' }
        this.SHARE_DATA_URL = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
        this.SHARE_DATA_TITLE = `Join our event LIVE on Novel - ${moment
            .utc(_.get(this.props, 'show.startTime'))
            .format('MMMM Do, h:mm a YYYY')} GMT`
        this.SHARE_LINK = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    }

    handleClickShare(e) {
        const sharer = new Sharer(e.currentTarget)
        sharer.share()
    }

    render() {
        return (
            <>
                <button
                    onClick={this.handleClickShare}
                    className="sharer button link-button"
                    id="share-facebook-btn"
                    data-sharer="facebook"
                    data-title={this.SHARE_DATA_TITLE}
                    data-url={this.SHARE_DATA_URL}
                >
                    <div className="social-icon">
                        <div className="social-icon-logo">
                            <FontAwesomeIcon icon={faFacebookF} color="#FA7F0F" />
                        </div>
                    </div>
                </button>
                <button
                    onClick={this.handleClickShare}
                    className="sharer button link-button"
                    id="share-twitter-btn"
                    data-sharer="twitter"
                    data-title={this.SHARE_DATA_TITLE}
                    data-url={this.SHARE_DATA_URL}
                >
                    <div className="social-icon">
                        <div className="social-icon-logo">
                            <FontAwesomeIcon icon={faTwitter} color="#FA7F0F" />
                        </div>
                    </div>
                </button>
                <button
                    onClick={this.handleClickShare}
                    className="sharer button link-button"
                    id="share-email-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-sharer="email"
                    data-title={`Click the link below to ${this.SHARE_DATA_TITLE}`}
                    data-to=""
                    data-subject={`Join LIVE on Novel`}
                    data-url={this.SHARE_DATA_URL}
                >
                    <div className="social-icon">
                        <div className="social-icon-logo">
                            <FontAwesomeIcon icon={faEnvelope} color="#FA7F0F" />
                        </div>
                    </div>
                </button>
                <CopyToClipboard text={this.SHARE_LINK} onCopy={() => this.setState({ copySuccess: 'Copied!' })}>
                    <button className="link-button">
                        <div className="social-icon">
                            <div className="social-icon-logo">
                                <FontAwesomeIcon icon={faLink} color="#FA7F0F" />
                            </div>
                        </div>
                    </button>
                </CopyToClipboard>
                {this.state.copySuccess && (
                    <div className="body-2" id="copy-success-text">
                        {this.state.copySuccess}
                    </div>
                )}
            </>
        )
    }
}

export default SharePopover
